import React, { useEffect, useState, Fragment } from 'react';
import { string } from 'prop-types';
import axios from 'axios';

import FullSizeLoader from '../../react-components/full-size-loader';

import { constEvent } from '../../utils/constants';
import { dispatchGenericEvent } from '../../utils/dispatch-events';

const ModalQuickView = ({ endpoint }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState(null);
  const [data, setData] = useState(null);

  useEffect(() => {
    document._on(constEvent.LOAD_QUICK_VIEW, loadQuickView.bind(this));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadQuickView = e => {
    const productId = e?.detail || null;

    setIsLoading(true);
    setErrorMessage(null);
    setData(null);

    fetchData(productId);
  };

  const fetchData = productId => {
    const url = `${endpoint}?product_id=${productId}`;

    axios({
      method: 'get',
      url,
      headers: {
        'content-type': 'application/json'
      }
    })
      .then(response => {
        const { success, body, message } = response?.data || {};

        if (success) {
          setData(body);

          const { productImages } = body || {};
          if (!productImages || productImages.length < 1) {
            dispatchGenericEvent(
              constEvent.MODAL_QUICK_VIEW_CONTAINER_NO_IMAGES
            );
          }
        } else {
          setErrorMessage(message);
        }
      })
      .catch(error => setErrorMessage(error.message))
      .finally(() => setIsLoading(false));
  }; //fetchData

  return (
    <div className="modal-quick-view__wrapper">
      {isLoading ? (
        <FullSizeLoader />
      ) : (
        <Fragment>
          {errorMessage ? (
            <p dangerouslySetInnerHTML={{ __html: errorMessage }} />
          ) : (
            <Fragment>
              {data?.productName ? (
                <Fragment>
                  {data?.productUrl ? (
                    <span className="modal-quick-view__name">
                      <a
                        href={data?.productUrl}
                        dangerouslySetInnerHTML={{ __html: data?.productName }}
                      />
                    </span>
                  ) : (
                    <span
                      className="modal-quick-view__name"
                      dangerouslySetInnerHTML={{ __html: data?.productName }}
                    />
                  )}
                </Fragment>
              ) : null}

              {data?.productNumber ? (
                <span className="modal-quick-view__number">
                  {data?.productNumber}
                </span>
              ) : null}

              <div className="modal-quick-view__columns">
                <div className="modal-quick-view__column modal-quick-view__col-1">
                  {data?.productDescription ? (
                    <div
                      className="modal-quick-view__description rte__wrapper"
                      dangerouslySetInnerHTML={{
                        __html: data?.productDescription
                      }}
                    />
                  ) : null}

                  {data?.productData && data?.productData?.length >= 1 ? (
                    <div className="modal-quick-view__data product-information">
                      <dl className="product-information__list">
                        {data?.productData?.map((item, index) => (
                          <Fragment key={index}>
                            <dt className="product-information__title">
                              {item?.title}
                            </dt>
                            <dd
                              className="product-information__data"
                              dangerouslySetInnerHTML={{ __html: item?.data }}
                            />
                          </Fragment>
                        ))}
                      </dl>
                    </div>
                  ) : null}
                </div>

                {data?.productImages && data?.productImages?.length >= 1 ? (
                  <div className="modal-quick-view__column modal-quick-view__col-2">
                    <div className="modal-quick-view__images">
                      {data?.productImages?.map((path, index) => (
                        <div className="modal-quick-view__img" key={index}>
                          <img src={path} />
                        </div>
                      ))}
                    </div>
                  </div>
                ) : null}
              </div>
            </Fragment>
          )}
        </Fragment>
      )}
    </div>
  );
};

ModalQuickView.propTypes = {
  endpoint: string.isRequired
};

export default ModalQuickView;
